import {
    Input,
    InputGroup,
    InputLeftElement,
    NumberInput,
    NumberInputField,
} from "@chakra-ui/react";
import React from "react";

const GrubInput = React.forwardRef((props, ref) => {
    if (props.posInput) {
        return (
            <Input
                id={props.id}
                ref={ref}
                width={props.width}
                autoFocus={props.autoFocus}
                placeholder={props.placeholder}
                onChange={props.handleInputChange}
                value={props.inputValue}
                onBlur={props.handleBlur}
                inputerror={props.inputError}
                height={props.height}
                onFocus={props.onFocus}
                onKeyDown={props.onKeyDown}
                background={props.background}
                isDisabled={props.disabled}
                fontSize={{ base: "0.87rem", md: "0.94rem" }}
                variant={
                    props.darkPlaceholder
                        ? "posDarkPlaceholder"
                        : "posBasicInput"
                }
                isInvalid={props?.inputError}
            />
        );
    } else if (props.posNumberInput) {
        return (
            <NumberInput
                variant={
                    props.darkPlaceholder
                        ? "posDarkPlaceholder"
                        : "posBasicInput"
                }
                precision={props.precision}
                value={props.inputValue}
                isInvalid={props.inputError}
                isDisabled={props.disabled}
            >
                <NumberInputField
                    id={props.id}
                    ref={ref}
                    autoFocus={props.autoFocus}
                    width={props.width}
                    onFocus={props.onFocus}
                    background={props.background}
                    placeholder={props.placeholder}
                    onChange={props.handleInputChange}
                    onKeyDown={props.onKeyDown}
                    onBlur={props.handleBlur}
                    inputerror={props.inputError}
                />
            </NumberInput>
        );
    } else if (props.posInputGroup) {
        return (
            <InputGroup>
                <InputLeftElement>{props.children}</InputLeftElement>
                <Input
                    id={props.id}
                    ref={ref}
                    variant={
                        props.darkPlaceholder
                            ? "posDarkPlaceholder"
                            : "posBasicInput"
                    }
                    width={props.width}
                    autoFocus={props.autoFocus}
                    placeholder={props.placeholder}
                    onChange={props.handleInputChange}
                    value={props.inputValue}
                    onBlur={props.handleBlur}
                    onKeyDown={props.onKeyDown}
                    isInvalid={props?.inputError}
                    onFocus={props.onFocus}
                    isDisabled={props.disabled}
                    type={props.inputType || "text"}
                />
            </InputGroup>
        );
    } else {
        return null;
    }
});

export default GrubInput;
